module.exports = __webpack_public_path__ + "static/img/Main-Banner1.f503b25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banners/Main-Banner1.jpg
// module id = 7WFK
// module chunks = 1